module.exports = __webpack_public_path__ + "static/media/bg1.58da725b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/bg1.png
// module id = 333
// module chunks = 0